import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IconSetService } from '@coreui/icons-angular';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { iconSubset } from './icons/icon-subset';
import { environment } from '../environments/environment';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';

@Component({
  selector: 'app-root',
  template: `
    <app-coming-soon *ngIf="showComingSoon; else mainApp"></app-coming-soon>

    <ng-template #mainApp>
      <router-outlet></router-outlet>
    </ng-template>
  `,
  standalone: true,
  imports: [CommonModule, RouterOutlet, ComingSoonComponent]
})
export class AppComponent implements OnInit {
  title = 'Healthbox Admin';
  showComingSoon = environment.maintenanceMode;

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService
  ) {
    this.titleService.setTitle(this.title);
    // iconSet singleton
    this.iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
}
